import React, {useState} from "react";
import {Autocomplete, TextField} from "@mui/material";

interface Props {
  onChange: (value:any) => void;
  rows: any;
}

export const ActivityField: React.ComponentType<Props> = ({onChange,rows}) => {

  return (<>
    <Autocomplete
      sx={{
        '& .MuiOutlinedInput-root':{
          backgroundColor: '#fff'
        }
      }}
      disablePortal
      size={'small'}
      options={rows}
      getOptionLabel={(option:any)=> option?.activity?.name}
      getOptionKey={(option:any)=> option?.id}
      isOptionEqualToValue={(option, value) => {
        return option.id === value.id;
      }}
      fullWidth={true}
      renderInput={(params) => <TextField {...params} label="Activity"  />}
      onChange={(event, value, reason, details) => onChange(value)}
    />
  </>);

}